import * as runtime from '@/api/runtime'
import {
  BatchOrderAcceptBreakingNewsPageLoadResult,
  BatchOrderAcceptBreakingNewsPageLoadResultFromJSON
} from '@/api/models/batch/BatchOrderAcceptBreakingNewsPageLoadResult'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchOrderAcceptBreakingNewsRequest,
  BatchOrderAcceptBreakingNewsRequestToJSON
} from '@/api/models/batch/BatchOrderAcceptBreakingNewsRequest'

export class BatchOrderAcceptBreakingNewsApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchOrderAcceptBreakingNewsPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchOrderAcceptBreakingNewsPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createOrderAcceptBreakingNews(
    request: BatchOrderAcceptBreakingNewsRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/order-accept/breaking-news`,
      BatchOrderAcceptBreakingNewsRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
